(function () {
    'use strict';
    var m = angular.module('dao');
    m.factory('mailHeaderConverterMT', ["$q", "parseMIMEByRFC2047", function ($q, parseMIMEByRFC2047) {
        return function (input) {
            function decodeString(text) {
                text = parseMIMEByRFC2047.decode(text);
                return text.split('\r');
            }
            if (input.data && input.data.headers) {
                return $q.when({
                    data: _(input.data.headers).map(function (value, key) {
                        var _value = '';
                        if (_(value).isString()) {
                            // if string
                            _value = decodeString(value);
                        } else if (_(value).isArray()) {
                            // if array
                            _value = _(value).map(function (val) {
                                return decodeString(val);
                            });
                        } else {
                            // if anything else
                            _value = ['' + value];
                        }
                        return {
                            key: key,
                            value: _value
                        };
                    })
                });
            }
            return $q.reject({ status: 404 });
        };
    }]);
}());